import { Component, Vue } from "vue-property-decorator";

import { BlankPage, Loading, Nav, Hint } from "@/components";
import { ScheduleReportModel } from "@/models";
import { TCBReceiptApi } from "@/network/pb/proto";

import { Priv } from "@/util/Priv";
import { DefaultPath } from "@/constant/GroupPermission";
import { Util } from "@/util/Util";

@Component<ReconciliationReportReportController>({
    components: {
        BlankPage,
        Nav,
        Loading,
        Hint,
    }
})
export default class ReconciliationReportReportController extends Vue {
    private isLoading = true;

    private expireTime = 0;
    private convertTimeToRepublicEra = Util.convertTimeToRepublicEra;
    private statusMap: {[k:number]: string} = {0: "處理中", 1: "成功", 2: "失敗"};
    
    // 元件
    private list: TCBReceiptApi.Protobuf.IScheduleReportInfo[] = [];
    private total = 0;

    // Hint
    private hintBox: { show: boolean, hint: string } = { show: false, hint: "" };

    // priv
    private priv = TCBReceiptApi.Protobuf.Permission.create();

    public async created() {
        /* 取得最新的權限map並判斷有何權限 */
        await this.setPriv();
        /* 取得最新的權限map並判斷有何權限 */

        await this.getList();
    }

    private async getList() {
        this.isLoading = true;

        // send value
        const reportList = await ScheduleReportModel.getReportList();
        this.list = reportList.list;
        this.total = this.list.length;

        console.log(reportList);
        console.log(this.total);
  
        this.isLoading = false;
    }

    private downloadFile(id: number) {
        const queryString = "id="+id.toString();
        console.log(queryString);
        ScheduleReportModel.downloadFile(queryString);
    }

    /* Hint */
    private openHint(hint: string) {
        this.hintBox.show = true;
        this.hintBox.hint = hint;
    }

    private closeHint() {
        this.hintBox.show = false;
        this.hintBox.hint = "";
    }
    /* Hint */

    /* 取得最新的權限map並判斷有何權限 */
    private async setPriv() {
        const meta = this.$route.meta as { privKey: { controller: string, method: string, type: string } };
        console.log(meta);

        const isSetPriv = await Priv._checkPriv(meta.privKey);
        if (!isSetPriv) {
            this.$router.push(DefaultPath);  // priv
        }

        if (!Priv._checkPrivType(meta.privKey.type)) {
            this.$router.push(DefaultPath);  // priv
        }

        this.expireTime = Priv._getExpireTime();
    }
    /* 取得最新的權限map並判斷有何權限 */
}
